import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';

import { StyledHighlightOffIcon } from 'globalStyles';
import PropTypes from 'prop-types';

/**
 * Renders one of two icons from a boolean — by default a secondary-colored
 * check-circle for `true` and the shared highlight-off (x) icon for `false`.
 * Use in table cells to display yes/no values.
 */
const TableIcon = ({ boolean, positiveIcon, negativeIcon }) =>
  boolean ? positiveIcon : negativeIcon;

TableIcon.defaultProps = {
  negativeIcon: <StyledHighlightOffIcon />,
  positiveIcon: <CheckCircleOutlineIcon color="secondary" />,
};

TableIcon.propTypes = {
  boolean: PropTypes.bool.isRequired,
  negativeIcon: PropTypes.node,
  positiveIcon: PropTypes.node,
};

export default TableIcon;
